<template>
  <div class="custom-form cmi-res">
    <div class="panel-body">
      <div class="panel panel-info cmi-search-header-panel">
        <div class="row cmi-search-wrapper">
          <div class="col-md-10 col-md-offset-1">
            <div class="cmi-search-header">
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Select by person name</span>
                </div>
                <div class="col-md-6 header-middle">
                  <select
                    id="per_FilterLabel"
                    name="per_FilterLabel"
                    @change="getFormDataByLabel"
                    v-model.trim="per_FilterLabel"
                    class="form-control"
                  >
                    <option></option>
                    <option
                      v-for="item in personLabels"
                      v-bind:value="item.value"
                      :key="item.value"
                      >{{ item.label }}</option
                    >
                  </select>
                </div>
                <div class="col-md-2 header-right">
                  <span
                    v-if="aniLabelsLoading"
                    class="fa fa-spinner fa-spin fa-3x fa-fw"
                  ></span>
                </div>
              </div>
              
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Search by ID number</span>
                </div>
                <div class="col-md-6 header-middle">
                  <masked-input
                    type="text"
                    name="per_FilterCode"
                    class="form-control"
                    :mask="[
                      /[A-Z]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i
                    ]"
                    :guide="false"
                    :showMask="false"
                    :pipe="toUpperCase"
                    v-model.trim="per_FilterCode"
                    spellcheck="false"
                  >
                  </masked-input>
                </div>
                <div class="col-md-2 cmi-search-header-btn-search">
                  <button
                    @click="getFormDataByCode"
                    v-bind:disabled="disableCriteriaMet_per_FilterCode"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Search
                  </button>
                </div>
              </div>

              <div class="row cmi-search-header-row">
                <div class="col-md-6 col-md-offset-3 cmi-search-header-btn-add">
                  <button
                    @click="newFormData"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Add new item
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Person details</h3>
        </div>

        <div class="panel-body">
          <div v-if="showPersonId" class="form-group">
            <label for="per_IdNumber">ID Number</label>
            <div
              id="per_IdNumber"
              name="per_IdNumber"
              class="form-control cmi-file-label"
            >
              {{ fdata.per_IdNumber }}
            </div>
          </div>
          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_File') }"
          >
            <label for="per_File">Select person's profile picture</label>
            <input
              ref="per_File"
              id="per_File"
              name="per_File"
              @change="onFileChange_per_File"
              v-validate.initial="{
                required: validateFileInput,
                mimes: ['image/*'],
                size: 30000
              }"
              class="form-control"
              type="file"
            />
            <span class="help-block">{{ errors.first("per_File") }}</span>
          </div>
          <div class="cmi-profile-image">
            <p>Profile picture preview</p>
            <img
              ref="per_FilePreview"
              v-bind:src="fdata.per_FilePreview"
              class="img-thumbnail"
              alt="Profile picture (thumbnail)"
            />
          </div>
          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_Title') }"
          >
            <label for="per_Title">Title</label>
            <select
              id="per_Title"
              name="per_Title"
              v-model.number="fdata.per_Title"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Pastor</option>
              <option value="2">Dr</option>
              <option value="3">Mr</option>
              <option value="4">Mrs</option>
              <option value="5">Elder</option>
              <option value="6">Deacon</option>
              <option value="7">Sister</option>
              <option value="8">Brother</option>
              <option value="9">Minister</option>
              <option value="97">Other</option>
            </select>
            <span class="help-block">{{ errors.first("per_Title") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_TitleText') }"
          >
            <label for="per_TitleText">Specify your title</label>
            <input
              id="per_TitleText"
              name="per_TitleText"
              v-model.trim="fdata.per_TitleText"
              v-validate="{
                required: !disableCriteriaMet_per_TitleText,
                max: 100
              }"
              v-bind:disabled="disableCriteriaMet_per_TitleText"
              maxlength="100"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("per_TitleText") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_FirstName') }"
          >
            <label for="per_FirstName">First name</label>
            <input
              id="per_FirstName"
              name="per_FirstName"
              v-model.trim="fdata.per_FirstName"
              v-validate.initial="{
                required: true,
                max: 50,
                valid_name: { active: true }
              }"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("per_FirstName") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_MiddleNames') }"
          >
            <label for="per_MiddleNames">Middle names</label>
            <input
              id="per_MiddleNames"
              name="per_MiddleNames"
              v-model.trim="fdata.per_MiddleNames"
              v-validate="{ max: 100, valid_name: { active: true } }"
              maxlength="100"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("per_MiddleNames")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_LastName') }"
          >
            <label for="per_LastName">Last name</label>
            <input
              id="per_LastName"
              name="per_LastName"
              v-model.trim="fdata.per_LastName"
              v-validate.initial="{
                required: true,
                max: 50,
                valid_name: { active: true }
              }"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("per_LastName") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_FavouriteVerse') }"
          >
            <label for="per_FavouriteVerse"
              >Favourite verse (book, chapter and verse)</label
            >
            <input
              id="per_FavouriteVerse"
              name="per_FavouriteVerse"
              v-model.trim="fdata.per_FavouriteVerse"
              v-validate.initial="{ required: true, max: 100 }"
              maxlength="100"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("per_FavouriteVerse")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_FavouriteVerseText') }"
          >
            <label for="per_FavouriteVerseText">Favourite verse text</label>
            <textarea
              id="per_FavouriteVerseText"
              name="per_FavouriteVerseText"
              v-model.trim="fdata.per_FavouriteVerseText"
              v-validate.initial="{ required: true, max: 1000 }"
              maxlength="1000"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("per_FavouriteVerseText")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_Ministry') }"
          >
            <label for="per_Ministry">Ministry</label>
            <select
              id="per_Ministry"
              name="per_Ministry"
              v-model="fdata.per_Ministry"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Management</option>
              <option value="2">Choir</option>
              <option value="3">Instrumentalist</option>
              <option value="4">Catering</option>
              <option value="5">Children</option>
              <option value="6">Giving</option>
              <option value="7">Intersection</option>
              <option value="8">Technical Team</option>
              <option value="9">Member</option>
              <option value="10">Visitor</option>
              <option value="97">Other</option>
            </select>
            <span class="help-block">{{ errors.first("per_Ministry") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_Comment') }"
          >
            <label for="per_Comment">Comments</label>
            <textarea
              id="per_Comment"
              name="per_Comment"
              v-model.trim="fdata.per_Comment"
              v-validate="{ max: 1000 }"
              maxlength="1000"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{ errors.first("per_Comment") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('per_Status') }"
          >
            <label for="per_Status">Status</label>
            <select
              id="per_Status"
              name="per_Status"
              v-model="fdata.per_Status"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
              <option value="90">Delete</option>
            </select>
            <span class="help-block">{{ errors.first("per_Status") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <modal
        name="alert-dialog-person"
        :width="400"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>

      <div class="btn-submit-wrapper">
        <div v-if="showAnimation" class="cc-animation">
          <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
          <span>Form submission in progress</span>
        </div>
        <div class="cc-submit-btn-wrapper">
          <button
            v-on:click="saveFormData"
            v-bind:disabled="showAnimation"
            type="submit"
            class="btn btn-primary"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "axios";
const path = "dist/assets/images/ResourceImages/";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        pkey: 0,
        per_IdNumber: "",
        per_Title: null,
        per_TitleText: "",
        per_FirstName: "",
        per_MiddleNames: "",
        per_LastName: "",
        per_FavouriteVerse: "",
        per_FavouriteVerseText: "",
        per_Ministry: null,
        per_Comment: "",
        per_Status: 1,
        per_FilePreview: `${path}cmi_no_image.jpg`,
        per_FilePreviewEditUrl: ""
      },
      showAnimation: false,
      subformIndex: 0,
      alertMessage: "",
      personLabels: [],
      per_FilterLabel: "",
      per_FilterCode: "",
      validateFileInput: true,
      aniLabelsLoading: false,
      fd: new FormData()
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    saveFormData: async function() {
      this.fd.delete("json");
      this.fd.append("json", JSON.stringify(this.fdata));

      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-person");
        return;
      }

      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}UpdateFormData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fd, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }
      if (rData != 0) {
        this.showAnimation = false;
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-person");
        return;
      }
      if (!this.fdata.pkey) {
        this.validateFileInput = true;
        this.resetFormData();
      }

      await this.getPersonLabels();
      this.alertMessage = "Your form has been submitted successfully";
      this.$modal.show("alert-dialog-person");
      this.showAnimation = false;
    },
    getFormDataByLabel: async function() {
      this.per_FilterCode = "";
      if (!this.per_FilterLabel) {
        this.resetFormData();
        return;
      }
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pkey: this.per_FilterLabel }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByLabel`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        if (rData.per_Thumbnail) {
          this.fdata.per_FilePreview = rData.per_Thumbnail;
          this.fdata.per_FilePreviewEditUrl = rData.per_Thumbnail;
        }
        this.$validator.errors.remove("per_File");
        this.validateFileInput = false;
      }

      this.aniLabelsLoading = false;
    },
    getFormDataByCode: async function() {
      this.per_FilterLabel = "";
      const per_FilterCode = this.per_FilterCode.replace(/\s/g, "");
      if (!per_FilterCode) {
        this.resetFormData();
        return;
      }

      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pcode: per_FilterCode }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByCode`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        if (rData.per_Thumbnail) {
          this.fdata.per_FilePreview = rData.per_Thumbnail;
          this.fdata.per_FilePreviewEditUrl = rData.per_Thumbnail;
        }
        this.$validator.errors.remove("per_File");
        this.validateFileInput = false;
      } else {
        this.resetFormData();
        this.alertMessage = "Item not found";
        this.$modal.show("alert-dialog-person");
      }
      this.aniLabelsLoading = false;
    },
    getPersonLabels: async function() {
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          params: { siteId: 2 }
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetPersonLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.personLabels, rData);
      }
      this.aniLabelsLoading = false;
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-person");
    },
    newFormData: function() {
      this.resetFormData();
      this.per_FilterLabel = "";
      this.per_FilterCode = "";
      this.validateFileInput = true;
    },
    onFileChange_per_File: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        if (this.fdata.per_FilePreviewEditUrl) {
          this.fdata.per_FilePreview = this.fdata.per_FilePreviewEditUrl;
        }
        return;
      }
      this.fdata.per_FilePreview = "";
      this.fd.delete("per_File");
      this.fd.append("per_File", files[0]);
      let reader = new FileReader();
      let self = this;
      reader.onload = function(e) {
        self.$refs.per_FilePreview.src = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    toUpperCase: function(value) {
      return value.toUpperCase();
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        pkey: 0,
        per_IdNumber: "",
        per_Title: null,
        per_TitleText: "",
        per_FirstName: "",
        per_MiddleNames: "",
        per_LastName: "",
        per_FavouriteVerse: "",
        per_FavouriteVerseText: "",
        per_Ministry: null,
        per_Comment: "",
        per_Status: 1,
        per_FilePreview: `${path}cmi_no_image.jpg`,
        per_FilePreviewEditUrl: ""
      });
      this.fd = new FormData();
      this.$refs.per_File.value = null;
    }
  },
  watch: {
    disableCriteriaMet_per_TitleText: function(newValue) {
      if (newValue == true) {
        this.fdata.per_TitleText = "";
      }
    }
  },
  computed: {
    showPersonId: function() {
      if (this.fdata.per_IdNumber) {
        return true;
      }
      return false;
    },
    disableCriteriaMet_per_FilterCode: function() {
      if (this.per_FilterCode && this.per_FilterCode.length == 16) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_per_TitleText: function() {
      if (
        this.fdata.per_Title != null &&
        [97].indexOf(this.fdata.per_Title) != -1
      ) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    await this.getPersonLabels();
  }
};
</script>
